<label class="switch" [class.animations]="initDone">
  <input
    type="checkbox"
    [disabled]="disabled"
    [ngModel]="value"
    (ngModelChange)="toggle()"
  />
  <span class="slider round" [class.disabled]="disabled"></span>
</label>
